import React from "react";
import { Form, Input, Radio, theme, Grid } from "antd";
import veryLightSvg from "../../../../../../assets/images/scalesImages/GrinningFace.png";
import light1Svg from "../../../../../../assets/images/scalesImages/GrinningFacewithSmilingEyes.png";
import light2Svg from "../../../../../../assets/images/scalesImages/SmilingFacewithSmilingEyes.png";
import moderate1Svg from "../../../../../../assets/images/scalesImages/ExpressionlessFace.png";
import moderate2Svg from "../../../../../../assets/images/scalesImages/WorriedFace.png";
import moderate3Svg from "../../../../../../assets/images/scalesImages/SlightlyFrowningFace.png";
import vigorous1Svg from "../../../../../../assets/images/scalesImages/PensiveFace.png";
import vigorous2Svg from "../../../../../../assets/images/scalesImages/DisappointedFace.png";
import veryHardSvg from "../../../../../../assets/images/scalesImages/AnguishedFace.png";
import maxEffortSvg from "../../../../../../assets/images/scalesImages/SleepyFace.png";
import light1M from "../../../../../../assets/images/scalesImages/mobileImages/light1.png";
import light2M from "../../../../../../assets/images/scalesImages/mobileImages/light2.png";
import maxEffortM from "../../../../../../assets/images/scalesImages/mobileImages/maxEffort.png";
import moderate1M from "../../../../../../assets/images/scalesImages/mobileImages/moderate1.png";
import moderate2M from "../../../../../../assets/images/scalesImages/mobileImages/moderate2.png";
import moderate3M from "../../../../../../assets/images/scalesImages/mobileImages/moderate3.png";
import veryHardM from "../../../../../../assets/images/scalesImages/mobileImages/veryHard.png";
import veryLightM from "../../../../../../assets/images/scalesImages/mobileImages/VeryLight.png";
import vigorous1M from "../../../../../../assets/images/scalesImages/mobileImages/vigorous1.png";
import vigorous2M from "../../../../../../assets/images/scalesImages/mobileImages/vigorous2.png";
const { useBreakpoint } = Grid;
const RPESelection = ({ nameKey = null, form, setRefresh = () => {} }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const { token } = theme.useToken();
  const desktopOptions = [
    { value: 1, label: "Very Light", image: veryLightSvg },
    { value: 2, label: "Light", image: light1Svg },
    { value: 3, label: "Light", image: light2Svg },
    { value: 4, label: "Moderate", image: moderate1Svg },
    { value: 5, label: "Moderate", image: moderate2Svg },
    { value: 6, label: "Moderate", image: moderate3Svg },
    { value: 7, label: "Vigorous", image: vigorous1Svg },
    { value: 8, label: "Vigorous", image: vigorous2Svg },
    { value: 9, label: "Very Hard", image: veryHardSvg },
    { value: 10, label: "Max Effort", image: maxEffortSvg },
  ];

  const mobileOptions = [
    { value: 1, label: "Very Light", image: veryLightM },
    { value: 2, label: "Light", image: light1M },
    { value: 3, label: "Light", image: light2M },
    { value: 4, label: "Moderate", image: moderate1M },
    { value: 5, label: "Moderate", image: moderate2M },
    { value: 6, label: "Moderate", image: moderate3M },
    { value: 7, label: "Vigorous", image: vigorous1M },
    { value: 8, label: "Vigorous", image: vigorous2M },
    { value: 9, label: "Very Hard", image: veryHardM },
    { value: 10, label: "Max Effort", image: maxEffortM },
  ];

  const rpeOptions = isMobile ? mobileOptions : desktopOptions;

  const handleRadioClick = (value) => {
    const name = nameKey ? [nameKey, "exertion"] : "exertion";
    const currentValue = form.getFieldValue(name);

    if (Array.isArray(name)) {
      // Create a nested object dynamically based on the array
      const nestedFieldUpdate = name.reduceRight(
        (acc, key, index) =>
          index === name.length - 1
            ? { [key]: currentValue === value ? null : value }
            : { [key]: acc },
        {}
      );
      form.setFieldsValue(nestedFieldUpdate);
      if (currentValue === value) {
        form.setFieldValue(
          nameKey ? [nameKey, "interpretation"] : "interpretation",
          ""
        );
      } else {
        form.setFieldValue(
          nameKey ? [nameKey, "interpretation"] : "interpretation",
          rpeOptions[value - 1]?.label
        );
      }
    } else {
      form.setFieldsValue({ [name]: currentValue === value ? null : value });
    }
    setRefresh((prev) => !prev);
  };
  return (
    <div className="physio-scales">
      <Form.Item
        name={nameKey ? [nameKey, "interpretation"] : "interpretation"}
        hidden
      >
        <Input />
      </Form.Item>
      <Form.Item name={nameKey ? [nameKey, "exertion"] : "exertion"}>
        <Radio.Group className="radio-group rpe-grid">
          {rpeOptions.map((option) => (
            <Radio.Button
              key={option.value}
              value={option.value}
              style={{
                height: 110,
                width: "100%",
                padding: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

                border:
                  form.getFieldValue(
                    nameKey ? [nameKey, "exertion"] : "exertion"
                  ) === option.value
                    ? `2px solid ${token.colorPrimary}`
                    : "1px solid #d9d9d9",

                background:
                  form.getFieldValue(
                    nameKey ? [nameKey, "exertion"] : "exertion"
                  ) === option.value
                    ? token.colorPrimaryBg
                    : "#fff",

                boxShadow:
                  form.getFieldValue(
                    nameKey ? [nameKey, "exertion"] : "exertion"
                  ) === option.value
                    ? `0 0 0 2px ${token.colorPrimary}33`
                    : "none",
              }}
              onClick={() => handleRadioClick(option.value)}
            >
              <div className="visual-option">
                {option.image && (
                  <img
                    src={option.image}
                    alt={option.label}
                    className="visual-image"
                  />
                )}
                <div className="visual-label">
                  <div className={`rpe-badge badge-${option.value}`}>
                    {option.value}
                  </div>
                  <div className="rpe-text">{option.label}</div>
                </div>
              </div>
            </Radio.Button>
          ))}
        </Radio.Group>
      </Form.Item>
    </div>
  );
};

export default RPESelection;
